export default __webpack_public_path__ + "static/media/close.bcf708d4.svg";